module.exports = require('./helpers/bundle-url').getBundleURL('cQKSD') + "lexus-upload.980c7877.png";